<template>

  <div class="mb-2 pa-2" style="border-radius: 4px; background-color: #FAFAFA;">

    <div class="header" v-if="!!this.$slots.header">
      <span><slot name="header"></slot></span>
    </div>

    <v-row>

      <v-col>
        <v-select
          :items="scopes"
          :value="scope"
          @input="onSelectScope"
          item-text="name"
          item-value="name"
          label="Scope"
          />
      </v-col>

      <v-col>

        <template v-if="scope == 'value'">

          <v-text-field :value="field" @input="onSelectField" label="Value" />

        </template>

        <template v-else-if="scope == 'constants'">

          <v-select
            :items="scopes.find(s => s.name == scope).attributes"
            :value="field"
            @input="onSelectField"
            item-text="name"
            item-value="id"
            :label="scope"
          />

        </template>

        <template v-else-if="scope == 'Stage Input'">

        </template>

        <template v-else>

          <v-select
            v-if="scope != null"
            :items="scopes.find(s => s.name == scope).attributes"
            :value="field"
            @input="onSelectField"
            item-text="name"
            item-value="name"
            :label="scope"
          />


        </template>

      </v-col>

    </v-row>

  </div>

</template>


<script>
export default {

  props: {

    scopes: {
      type: Array
    },

    scope: {
      type: String,
      required: true,
    },

    field: {
      type: String,
      required: true
    },

  },

  data() {

    return {


    }

  },

  methods: {

    onSelectScope(val) {

      if(val == 'Stage Input') {
        this.$emit('field', null);
      }

      this.$emit('scope', val);

    },

    onSelectField(val) {
      this.$emit('field', val);
    }

  }


}

</script>


<style lang="scss">

  .header {
    span {
      font-weight: bold;
      padding: 2px 8px;
      font-size: 11px;
      background-color: #E5E5E5;
    }
  }

</style>
